/* eslint-disable prefer-regex-literals */
import classNames from 'classnames';
import Image from 'next/image';

import SectionTitle from '../SectionTitle/SectionTitle';
import TextBlock from '../TextBlock/TextBlock';

import styles from './Advantageous.module.scss';

const Advantageous = ({ advantageousData }) => {
  const renderCardItem = (item, index) => {
    const splitUssdCode = (text) => {
      const regExp = new RegExp(/[\^*].*#/gm, 'gi');

      return text?.toString().replace(regExp, (match) =>
        [...match]
          .map((item) => {
            return `<a title='Bakcell' arial-label='Bakcell' href='tel:${match.replace(
              /#/g,
              '%23',
            )}' class='number_item' key={index}>${item}</a>`;
          })
          .join(' '),
      );
    };
    return (
      <article
        className={styles['advantageous-card']}
        key={index}
        itemScope
        itemType='https://schema.org/Article'
      >
        {item?.icon && (
          <Image
            src={item?.icon}
            alt={item?.title}
            title={item?.title}
            className={styles['advantageous-card__icon-wrapper']}
            loading='lazy'
            width={24}
            height={24}
          />
        )}
        <div className={styles['advantageous-card__content']}>
          {item?.title && (
            <h2
              className={classNames(
                'title',
                'title--extend',
                styles['advantageous-card__title'],
              )}
            >
              {item?.title}
            </h2>
          )}
          <div
            className={classNames(
              'text',
              'text--lite-gray',
              'text--small',
              styles['advantageous-card__text'],
            )}
            dangerouslySetInnerHTML={{
              __html: splitUssdCode(item?.description),
            }}
          ></div>
        </div>
      </article>
    );
  };

  return (
    <div
      className='wrapper small-margin'
      itemScope
      itemType='https://schema.org/Offer'
    >
      <section className={styles.advantageous}>
        <div className={styles['advantageous__title-block']}>
          <SectionTitle
            className={styles.advantageous__title}
            titleModify='title--large'
          >
            {advantageousData?.title}
          </SectionTitle>
          <TextBlock
            isHtml
            className={classNames('text--large', styles.advantageous__text)}
          >
            {advantageousData?.description}
          </TextBlock>
        </div>
        <div className={classNames(styles.advantageous__inner, 'small-margin')}>
          {advantageousData?.sections?.map(renderCardItem)}
        </div>
      </section>
    </div>
  );
};

export default Advantageous;
